import { ajax, get as jQueryGet } from 'jquery';

export const formatPhone = value => {
    // Remove all non-numeric or + characters
    value = value.replace(/[^0-9+]/g, '');

    // Make sure entry starts with +61 or +64
    const country = typeof(__COUNTRY__) !== 'undefined' ? __COUNTRY__ : process.env.COUNTRY;
    let prefix = country === 'NZ' ? '64' : '61';

    // Starts with '00' instead of +?
    if (value.indexOf('00') === 0) {
        value = '+' + value.substr(2);
    }

    // Add the prefix
    if (value.indexOf('+') !== 0) {
        value = '+' + prefix + value;
    }

    // Make sure there's no 0 after the prefix
    if (value.substr(3, 1) === '0') {
        value = value.substr(0, 3) + value.substr(4);
    }

    return value;
};

// Custom JSON POST function for jQuery. jQuery turns body into URL params automatically.
export const post = function (url, body) {
    return ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(body),
        contentType: "application/json",
        dataType: 'json'
    });
}

export const get = jQueryGet;

// TODO - Move to SWR
const getCache = {};
export const cachedGet = async url => {
    if (!getCache[url]) {
        getCache[url] = await get(url);
    }

    return getCache[url];
};

export const formatMoney = (amount) => {
    try {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(amount||0);
    } catch (error) {
        console.error('Error formatting money:', error);
        return amount;
    }
};